// v2/components/CurrencyCard.js
import React, { useEffect, useRef, useState } from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { formatNumber, formatPercent } from '../utils/format';
import layout from '../styles/HomeLayout.module.css';
import styles from './StatCards.module.css';
import flash from './CurrencyCard.module.css';

/** Deger degisince kisa flas + sayarak gecis */
function useRateFlash(rate) {
  const [dir, setDir] = useState(null);          // 'up' | 'down' | null
  const [shown, setShown] = useState(rate);
  const prev = useRef(rate);
  const raf = useRef(null);
  const timer = useRef(null);

  useEffect(() => {
    const from = prev.current;
    if (from === rate || !Number.isFinite(rate)) { prev.current = rate; setShown(rate); return undefined; }

    setDir(rate > from ? 'up' : 'down');
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setDir(null), 1100);

    const reduce = typeof window !== 'undefined'
      && typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce) { setShown(rate); prev.current = rate; return () => clearTimeout(timer.current); }

    const t0 = (typeof performance !== 'undefined' ? performance.now() : Date.now());
    const delta = rate - from;
    const tick = (now) => {
      const pr = Math.min((now - t0) / 520, 1);
      setShown(from + delta * (1 - Math.pow(1 - pr, 3)));
      if (pr < 1) raf.current = requestAnimationFrame(tick);
      else prev.current = rate;
    };
    raf.current = requestAnimationFrame(tick);

    return () => {
      if (raf.current) cancelAnimationFrame(raf.current);
      clearTimeout(timer.current);
    };
  }, [rate]);

  return { dir, shown };
}

function CurrencyLine({ item }) {
  const degisimVar = Number.isFinite(item.changePct);
  const up = degisimVar && item.changePct >= 0;
  const Icon = up ? ArrowUpRight : ArrowDownRight;
  const { dir, shown } = useRateFlash(item.rate);

  const flashCls = dir === 'up' ? flash.flashUp : dir === 'down' ? flash.flashDown : '';

  return (
    <div className={`${styles.curLine} ${flash.line} ${flashCls}`}>
      <span className={styles.curBig}>{item.code}</span>
      <span className={styles.curSub}>
        {item.label}
        {item.stale && item.rateDate ? (
          <em className={styles.curStale} title={`Son guncelleme: ${item.rateDate}`}>
            {item.rateDate}
          </em>
        ) : null}
      </span>
      {degisimVar ? (
        <span className={`${styles.statTrend} ${up ? styles.up : styles.down} ${dir ? flash.trendPulse : ''}`}>
          <Icon size={11} />{formatPercent(Math.abs(item.changePct), 2)}
        </span>
      ) : (
        <span className={styles.statTrend} />
      )}
      <span className={`${styles.curNum} ${flash.num}`}>{formatNumber(shown, 4)}</span>
    </div>
  );
}

export default function CurrencyCard({ items = [], asOf }) {
  return (
    <section className={layout.panel} aria-label="Güncel Kurlar">
      <div className={layout.panelHead}>
        <span className={layout.bar} />
        <h2 className={layout.panelTitle}>Güncel Kurlar</h2>
        <span className={layout.headSpacer} />
        {asOf && <span className={layout.headChip}>{asOf}</span>}
      </div>
      <div className={styles.curList}>
        {items.map((c) => <CurrencyLine key={c.code} item={c} />)}
      </div>
    </section>
  );
}
